<template lang="pug">
  .yz-dialog-normal-action-wrapper
    yz-divider(:color="dividerColor")
    yz-card-actions.d-flex.align-center(:class="[titleClasses, getJustifyClass]" :style="`width: 100%; gap: ${getActionGap}`")
      slot
        yz-btn(size="lg" text :underline="cancelActionUnderline" :text-color="cancelActionColor" :label="cancelLabel" :disabled="loading || disableCancel" @click="handleCancel")
        yz-btn(size="lg" :label="saveLabel" :color="saveActionColor" :loading="loading" :disabled="disableSave" @click="handleSave")
</template>

<script>
import {getParentClasses, hasPaddingClasses} from '@/utils'

export default {
  name: 'YzDialogNormalActions',
  props: {
    saveLabel: {
      type: String,
      default: 'Save'
    },
    cancelLabel: {
      type: String,
      default: 'Cancel'
    },
    cancelActionUnderline: {
      type: Boolean,
      default: false
    },
    cancelActionColor: {
      type: String,
      default: 'yz-neutral-700'
    },
    actionGap: {
      type: [String, Number],
      default: '12px'
    },
    justify: {
      type: String,
      default: 'end',
      validator: value => ['space-between', 'space-around', 'space-evenly', 'center', 'start', 'end'].includes(value)
    },
    loading: {
      type: Boolean,
      default: false
    },
    dividerColor: {
      type: String,
      default: 'yz-neutral-300'
    },
    disableCancel: {
      type: Boolean,
      default: false
    },
    disableSave: {
      type: Boolean,
      default: false
    },
    saveActionColor: {
      type: String,
      default: 'primary'
    }
  },
  computed: {
    titleClasses() {
      const parentClass = getParentClasses(this.$vnode)

      if (hasPaddingClasses(parentClass)) {
        // Extract and return only the padding classes
        return this.extractPaddingClasses(parentClass)
      }

      return 'px-6 py-3'
    },
    getActionGap() {
      return typeof this.actionGap === 'number' ? `${this.actionGap}px` : this.actionGap
    },
    getJustifyClass() {
      return `justify-${this.justify}`
    }
  },
  methods: {
    handleCancel() {
      this.$emit('cancel')
    },
    handleSave() {
      this.$emit('save')
    },
    extractPaddingClasses(classString) {
      // Extract only padding-related classes
      const classes = classString.split(' ')
      return classes.filter(c => /^(pa-|pt-|pr-|pb-|pl-|px-|py-)\d+$/.test(c)).join(' ')
    }
  }
}
</script>

<style lang="scss" scoped>
.yz-dialog-normal-action-wrapper {
  // Remove all padding that might be inherited
  padding: 0 !important;
  border-bottom-right-radius: 10px !important;
  border-bottom-left-radius: 10px !important;
}
</style>